var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 31.5,
    height: 23.5,
    rx: 1.75,
    fill: "white",
    stroke: "#848C9B",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7726 16.3952C20.9899 16.3952 20.2553 16.1304 19.7013 15.6431L16.7148 13.0161C16.5101 12.836 16.1368 12.836 15.9321 13.0161L12.9335 15.6537C12.3795 16.141 11.645 16.4058 10.8622 16.4058H10.2721L14.0534 19.7319C15.2336 20.77 17.1483 20.77 18.3285 19.7319L22.1218 16.3952H21.7726Z",
    fill: "#32BCAD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8702 7.10468C11.6529 7.10468 12.3875 7.3695 12.9415 7.85676L15.94 10.4943C16.1568 10.685 16.506 10.685 16.7228 10.4943L19.7093 7.86735C20.2632 7.38009 20.9978 7.11527 21.7806 7.11527H22.1419L18.3485 3.77857C17.1684 2.74048 15.2536 2.74048 14.0735 3.77857L10.2921 7.10468H10.8702Z",
    fill: "#32BCAD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.271 9.87813L22.9829 7.86552C22.9347 7.8867 22.8745 7.8973 22.8143 7.8973H21.7666C21.2247 7.8973 20.6948 8.08797 20.3215 8.42694L17.335 11.0539C17.058 11.2976 16.6847 11.4247 16.3235 11.4247C15.9622 11.4247 15.5889 11.2976 15.3119 11.0539L12.3133 8.41634C11.928 8.07737 11.4102 7.8867 10.8683 7.8867H9.59177C9.53155 7.8867 9.48339 7.87611 9.43522 7.85493L7.13512 9.87813C5.95496 10.9162 5.95496 12.6005 7.13512 13.6386L9.43522 15.6618C9.48339 15.6406 9.53155 15.63 9.59177 15.63H10.8683C11.4102 15.63 11.928 15.4393 12.3133 15.1004L15.3119 12.4628C15.8538 11.9861 16.7931 11.9861 17.335 12.4628L20.3215 15.0898C20.7069 15.4287 21.2247 15.6194 21.7666 15.6194H22.8143C22.8745 15.6194 22.9227 15.63 22.9829 15.6512L25.271 13.6386C26.4511 12.6005 26.4511 10.9162 25.271 9.87813Z",
    fill: "#32BCAD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPix);
export default __webpack_public_path__ + "static/media/pix.2f47b9f120e8a5b47d644389df9e7bf2.svg";
export { ForwardRef as ReactComponent };